import { useIsomorphicLayoutEffect } from "../../hooks";
import { matterFontFamilyStyle } from "../../styles/fonts.css";

export const ApplyFontFamily = () => {
  useIsomorphicLayoutEffect(() => {
    document.body.classList.add(matterFontFamilyStyle);
  }, []);

  return null;
};
